// extracted by mini-css-extract-plugin
export default {"img_constru":"style_img_constru__n-vZL"};